<template>
    <div class="loginPanel">
        <vue-particles class="vue-particles" color="#8EB5C9" :particleOpacity="0.7" :particlesNumber="80"
            shapeType="star" :particleSize="4" linesColor="#8EB5C9" :linesWidth="1" :lineLinked="true"
            :lineOpacity="0.4" :linesDistance="150" :moveSpeed="3" :hoverEffect="true" hoverMode="grab"
            :clickEffect="true" clickMode="push" ref="particles">
        </vue-particles>

        <div class="boardLogin">
            <div class="logo">
                <img src="../assets/loginLogo.png">
            </div>
            <form>
                <div class="inpGroup">
                    <span class="loginIco1"></span>
                    <input type="text" name="" placeholder="请输入您的用户名" v-model="userName">
                </div>
                <div class="prompt">
                    <p class="error">用户名错误或不存在</p>
                </div>

                <div class="inpGroup">
                    <span class="loginIco2"></span>
                    <input type="password" name="" placeholder="请输入您的密码" v-model="password"
                        @keyup.enter.prevent="loginInHandler">
                </div>
                <div class="prompt">
                    <p class="success">输入正确</p>
                </div>

                <!-- <button class="submit">登录</button> -->
                <a class="animsition-link submit" @click.prevent="loginInHandler">登录</a>
            </form>
        </div>

        <!-- 加载动画 -->
        <div class="loadingPanel" v-if="isLoading">
            <img src="../assets/jzxz1.png" alt="">
            <img src="../assets/jzxz2.png" alt="">
        </div>
    </div>
</template>

<script>
import { MessageBox } from 'element-ui';
/**
 * 登录模块
 * 
 * 集成背景粒子效果库 
 * npm install vue-particles --save
 * // 配置参考
 * color: String类型。默认’#dedede’。粒子颜色。
 * particleOpacity: Number类型。默认0.7。粒子透明度。
 * particlesNumber: Number类型。默认80。粒子数量。
 * shapeType: String类型。默认’circle’。可用的粒子外观类型有：“circle”,“edge”,“triangle”, “polygon”,“star”。
 * particleSize: Number类型。默认80。单个粒子大小。
 * linesColor: String类型。默认’#dedede’。线条颜色。
 * linesWidth: Number类型。默认1。线条宽度。
 * lineLinked: 布尔类型。默认true。连接线是否可用。
 * lineOpacity: Number类型。默认0.4。线条透明度。
 * linesDistance: Number类型。默认150。线条距离。
 * moveSpeed: Number类型。默认3。粒子运动速度。
 * hoverEffect: 布尔类型。默认true。是否有hover特效。
 * hoverMode: String类型。默认true。可用的hover模式有: “grab”, “repulse”, “bubble”。
 * clickEffect: 布尔类型。默认true。是否有click特效。
 * clickMode: String类型。默认true。可用的click模式有: “push”, “remove”, “repulse”, “bubble”
 */
export default {
    name: "LoginTool",
    data() {
        return {
            isLoading: false,
            userName: "admin",
            password: "admin123"
        }
    },
    created() {
        if (localStorage.getItem("isLogin")) {
            this.$emit("login-success", {
                // 此处包含一些登录信息
            });
        }
    },
    methods: {
        loginInHandler() {
            this.isLoading = true;
            if (this.userName === "admin" && this.password === "admin123") {
                setTimeout(() => {
                    this.isLoading = false;
                    // 写入登录状态至缓存(集成SSO后，改为接口调用登录)
                    localStorage.setItem('isLogin', 'true');
                    this.$emit("login-success", {
                        // 此处包含一些登录信息
                    });
                }, 1500);
                return;
            }
            setTimeout(() => {
                this.isLoading = false;
                MessageBox.alert('账号或密码错误！', '错误提示', {
                    confirmButtonText: '确定',
                    callback: () => {
                        console.log(this.userName, this.password);
                    }
                });
            }, 1500);
        }
    }
}

</script>

<style lang="scss" scoped>
$icon6-image: "@/assets/s_ico6.png";
$icon7-image: "@/assets/s_ico7.png";

@keyframes xz1 {
    from {
        transform: rotate(0deg);
    }

    50% {
        transform: rotate(180deg);
    }

    to {
        transform: rotate(360deg);
    }
}

@keyframes xz2 {
    from {
        transform: rotate(0deg);
    }

    50% {
        transform: rotate(-180deg);
    }

    to {
        transform: rotate(-360deg);
    }
}

// 加载效果
.loadingPanel {
    user-select: none;
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(3px);
    z-index: 999999;

    >img:nth-child(1) {
        position: absolute;
        animation: xz1 8s infinite linear;
    }

    >img:nth-child(2) {
        position: absolute;
        animation: xz2 7s infinite linear;
    }
}

// 粒子效果库，id为库DOM标签自带id名称
#particles-js {
    position: absolute;
    /* 为防止页面有其他的内容时会挤下去 */
    height: 100%;
    width: 100%;
    overflow: hidden;
}

.loginPanel {
    width: 100%;
    height: 100%;
    background-image: url('../assets/loginBg.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;

    input {
        background: none;
        border: none;
        outline: none;
        -webkit-appearance: none;
    }

    .boardLogin {
        width: 16.8%;
        min-width: 200px;
        margin: 0 auto;
        position: relative;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);

        &::after {
            content: "";
            position: absolute;
            width: 120%;
            height: 120%;
            top: -10%;
            left: -10%;
            border-radius: 0.5rem;
            background-color: rgba(255, 255, 255, 0.1);
            z-index: -1;
            box-shadow: 0px 0px 5px #2a8aa6;
            backdrop-filter: blur(3px);
        }
    }

    .boardLogin .logo {
        display: block;
        margin-bottom: 20px;
        text-align: center;
    }

    .boardLogin .logo img {
        width: 100%;
        max-width: 326px;
    }

    .boardLogin .inpGroup {
        height: 20px;
        padding: 14px 24px 14px 52px;
        background: #2a658a;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 24px;
        position: relative;
    }

    .boardLogin .inpGroup span {
        display: block;
        width: 20px;
        height: 20px;
        position: absolute;
        top: 14px;
        left: 24px;
    }

    .boardLogin .inpGroup span.loginIco1 {
        background: url('#{$icon6-image}');
    }

    .boardLogin .inpGroup span.loginIco2 {
        background: url('#{$icon7-image}');
    }

    .boardLogin .inpGroup input {
        display: block;
        width: 100%;
        height: 20px;
        line-height: 20px;
        color: #fff;
    }

    .boardLogin .inpGroup input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #fff;
        opacity: 1;
    }

    .boardLogin .inpGroup input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #fff;
        opacity: 1;
    }

    .boardLogin .inpGroup input:-ms-input-placeholder {
        color: #fff;
        opacity: 1;
    }

    .boardLogin .inpGroup input::-webkit-input-placeholder {
        color: #fff;
        opacity: 1;
    }

    .boardLogin .prompt {
        min-height: 20px;
        padding: 5px 24px 10px 24px;
    }

    .boardLogin p {
        line-height: 16px;
        font-size: 12px;
        display: none;

    }

    .boardLogin p.error {
        color: #f60;
    }

    .boardLogin p.success {
        color: #449d44;
    }

    .boardLogin .submit {
        width: 100%;
        box-sizing: border-box;
        display: block;
        height: 40px;
        line-height: 38px;
        text-align: center;
        border: 1px solid #01d1f2;
        border-radius: 20px;
        color: #fff;
        cursor: pointer;
        -webkit-transition: 0.3s ease-in-out;
        -moz-transition: 0.3s ease-in-out;
        -ms-transition: 0.3s ease-in-out;
        -o-transition: 0.3s ease-in-out;
        transition: 0.3s ease-in-out;
    }

    .boardLogin .submit:hover {
        background: #01d1f2;
        -webkit-transition: 0.3s ease-in-out;
        -moz-transition: 0.3s ease-in-out;
        -ms-transition: 0.3s ease-in-out;
        -o-transition: 0.3s ease-in-out;
        transition: 0.3s ease-in-out;
    }


}

@media screen and (max-width: 1919px) and (min-width: 1680px) {
    .boardLogin .logo {
        margin-bottom: 38px;
    }

    .boardLogin .inpGroup {
        padding: 12px 22px 12px 50px;
        border-radius: 22px;
    }

    .boardLogin .inpGroup span {
        width: 20px;
        height: 20px;
        top: 12px;
        left: 22px;
    }

    .boardLogin .prompt {
        min-height: 20px;
        padding: 5px 22px 10px 22px;
    }

    .boardLogin p {
        line-height: 16px;

    }

    .boardLogin .submit {
        height: 38px;
        line-height: 36px;
        border-radius: 20px;
    }
}

@media screen and (max-width: 1679px) and (min-width: 1440px) {
    .boardLogin .logo {
        margin-bottom: 34px;
    }

    .boardLogin .inpGroup {
        padding: 8px 18px 8px 48px;
        border-radius: 18px;
    }

    .boardLogin .inpGroup span {
        width: 18px;
        height: 18px;
        top: 8px;
        left: 18px;
    }

    .boardLogin .inpGroup span.loginIco1 {
        background: url('#{$icon6-image}');
        background-size: 100% 100%;
    }

    .boardLogin .inpGroup span.loginIco2 {
        background: url('#{$icon7-image}');
        background-size: 100% 100%;
    }

    .boardLogin .prompt {
        min-height: 20px;
        padding: 5px 18px 10px 18px;
    }

    .boardLogin p {
        line-height: 16px;

    }

    .boardLogin .submit {
        height: 36px;
        line-height: 34px;
        border-radius: 18px;
    }
}

@media screen and (max-width: 1439px) {
    .boardLogin .logo {
        margin-bottom: 30px;
    }

    .boardLogin .inpGroup {
        padding: 6px 16px 6px 46px;
        border-radius: 16px;
    }

    .boardLogin .inpGroup span {
        width: 18px;
        height: 18px;
        top: 6px;
        left: 16px;
    }

    .boardLogin .inpGroup span.loginIco1 {
        background: url('#{$icon6-image}');
        background-size: 100% 100%;
    }

    .boardLogin .inpGroup span.loginIco2 {
        background: url('#{$icon7-image}');
        background-size: 100% 100%;
    }

    .boardLogin .prompt {
        min-height: 20px;
        padding: 2px 16px 6px 16px;
    }

    .boardLogin p {
        line-height: 16px;

    }

    .boardLogin .submit {
        height: 32px;
        line-height: 30px;
        border-radius: 16px;
    }
}
</style>